import { Helmet } from "react-helmet-async";
import { useEffect, useState, useCallback } from "react";
import { Stack, Container, Typography } from "@mui/material";
import FixtureFeedsTable from "../components/fixture-feeds/FixtureFeedsTable";
import { get } from "src/utils/networkUtils";
export default function FixturesBasicFeedsPage() {
  const [loading, setLoading] = useState(true);
  const [feeds, setFeeds] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(25);
  const fetchFeeds = useCallback(
    async (currentOffset = 0, isInitial = false) => {
      if (isInitial) {
        setLoading(true);
      }

      try {
        const response = await get(
          `/admin/fixtures/basic?offset=${currentOffset}&limit=${limit}`
        );
        const newFeeds = response.feeds || [];

        if (isInitial) {
          setFeeds(newFeeds);
        } else {
          setFeeds((prev) => [...prev, ...newFeeds]);
        }

        setTotalCount(response.totalCount || 0);
        setHasMore(newFeeds.length === limit);
        setOffset(currentOffset + limit);
      } catch (error) {
        console.error("Error fetching basic feeds:", error);
        if (isInitial) {
          setFeeds([]);
        }
      } finally {
        if (isInitial) {
          setLoading(false);
        }
      }
    },
    [limit]
  );

  const handleLoadMore = useCallback(() => {
    if (!hasMore) return;
    return fetchFeeds(offset);
  }, [fetchFeeds, offset, hasMore]);

  useEffect(() => {
    setFeeds([]);
    setOffset(0);
    setHasMore(true);
    fetchFeeds(0, true);
  }, [fetchFeeds]);

  return (
    <>
      <Helmet>
        <title>Basic Fixture Feeds</title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={3}
        >
          <Typography variant="h4" gutterBottom>
            Basic Fixture Feeds
          </Typography>
        </Stack>

        <FixtureFeedsTable
          loading={loading}
          feeds={feeds}
          totalCount={totalCount}
          onLoadMore={handleLoadMore}
          hasMore={hasMore}
        />
      </Container>
    </>
  );
}
